import { Actions } from './system-settings.actions'
import { fromJS } from 'immutable'
import * as SystemSettingsTypes from './system-settings.types'

export const initialState = fromJS<any>({
  isLoading: false,
  validationErrors: {},
  data: {},
})

export function systemSettingsReducer(state = initialState, action: Actions) {
  switch (action.type) {
    case SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_SUCCESS: {
      return state.set('isLoading', false)
    }

    case SystemSettingsTypes.UPDATE_SYSTEM_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_REQUEST: {
      return state.set('isLoading', true)
    }

    case SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_SUCCESS: {
      return state.set('isLoading', false).set('data', fromJS(action.payload))
    }

    case SystemSettingsTypes.FETCH_SYSTEM_SETTINGS_FAILURE: {
      return state.set('isLoading', false)
    }

    case SystemSettingsTypes.UPDATE_FIELD:
      let fields = []

      if (action.path === '') {
        fields = action.field.split('.')
      } else {
        fields = action.path.split('.').concat(action.field.split('.'))
      }
      const value = action.value

      if (fields.length === 1) {
        return state.set(fields[0], fromJS(value))
      }
      return state.setIn(fields, fromJS(value))
    case SystemSettingsTypes.SET_DEFAULT_DATA:
      const path = action.path || ''
      return state.setIn(path.split('.'), initialState.getIn(path.split('.')))

    default:
      return state
  }
}
